export default __webpack_public_path__ + "static/media/lottery-img.8cfcd7c5.webp";